(function ($) {

	var OdaTrackAction = function () {};

	OdaTrackAction.prototype.init = function () {
		this.initEvents();
	};

	OdaTrackAction.prototype.initEvents = function () {
		$('.oda-click').on('click', $.proxy(this.handleClick, this));
	};

	OdaTrackAction.prototype.handleClick = function (e) {
		var name = $(e.currentTarget).data('oda-name');
		_waq.push(['_trackAction', { category: this.getPageCategory(), name: name }]);
	};

	OdaTrackAction.prototype.getPageCategory = function () {
		return $(document.body).data("oda-category");
	};

	//Instantiate Globally
	var odaTrackActionClick = new OdaTrackAction();
	odaTrackActionClick.init();

})(jQuery);
